import { Box } from "@chakra-ui/layout";
import { useState } from "react";
import Chatbox from "../components/Chatbox";
import MyChats from "../components/MyChats";
import { Button, useDisclosure } from "@chakra-ui/react";
// import SideDrawer from "../components/miscellaneous/SideDrawer";
import { ChatState } from "../Context/ChatProvider";
import { ChakraProvider } from "@chakra-ui/react";
import useWindowDimensions from "../../CustomHooks/useWindowdimension";
const Chatpage = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
  const [fetchAgain, setFetchAgain] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const {height ,width} = useWindowDimensions()
  const { user } = ChatState();
  const handleCloseDrawer = ()=>{
    setIsDrawerOpen(false)
   }
  return (
    <ChakraProvider>
    <div className="flex item-center justify-center mt-7">
      <Box className="mainchatapppage"  style={{marginTop:width > 768 ?"70px":"30px"}}>
        {user && <MyChats fetchAgain={fetchAgain}
         isDrawerOpen={isDrawerOpen}
         handleCloseDrawer={handleCloseDrawer}
         isOpen={isOpen}
         onOpen={onOpen}
         onClose={onClose}
          />}
        {user && (
          <Chatbox fetchAgain={fetchAgain} setFetchAgain={setFetchAgain} setIsDrawerOpen={setIsDrawerOpen}  onOpen={onOpen}/>
        )}
      </Box>
    </div>
    </ChakraProvider>
  );
};



export default Chatpage;
